module.exports = __webpack_public_path__ + "img/logo-bold-white.a05fcb2b.png";